import { useTranslation } from 'react-i18next';
import usePageMeta from '@/hooks/usePageMeta';
import PageHero from '@/components/feature/PageHero';
import Reveal from '@/components/base/Reveal';
import { SITE } from '@/constants/site';

export default function Imprint() {
  const { t } = useTranslation();

  usePageMeta({
    title: 'Impressum | S+N Blech- und Metallverarbeitung',
    description:
      'Impressum der S+N Blech- und Metallverarbeitungs GmbH: Anschrift, Kontakt, Geschäftsführer, Registereintrag und Umsatzsteuer-Identifikationsnummer.',
    keywords: 'Impressum, S+N Metall, Lauter-Bernsbach, HRB 19316',
  });

  const addressItems = [
    { label: t('imprint.representativeTitle'), value: SITE.managingDirector, icon: 'ri-user-line' },
    { label: t('imprint.registerTitle'), value: SITE.register, icon: 'ri-file-list-3-line' },
    { label: t('imprint.vatTitle'), value: SITE.vat, icon: 'ri-percent-line' },
  ];

  return (
    <>
      <PageHero eyebrow={t('imprint.hero.eyebrow')} title={t('imprint.hero.title')} subtitle={t('imprint.hero.subtitle')} />

      <section className="bg-background-50 py-16 md:py-24">
        <div className="mx-auto grid w-full max-w-content grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <div className="rounded-lg border border-background-200 bg-background-100 p-6">
              <h2 className="font-heading text-lg font-bold text-foreground-950">{t('imprint.addressTitle')}</h2>
              <address className="mt-4 not-italic text-sm leading-relaxed text-foreground-700">
                <span className="block font-semibold text-foreground-900">{SITE.name}</span>
                <span className="mt-1 block">{SITE.street}</span>
                <span className="block">{SITE.city}</span>
              </address>

              <h2 className="mt-8 font-heading text-lg font-bold text-foreground-950">{t('imprint.contactTitle')}</h2>
              <ul className="mt-4 space-y-3 text-sm">
                <li className="flex items-center gap-3 text-foreground-700">
                  <i className="ri-phone-line text-base text-primary-600" />
                  <a href={SITE.phoneHref} className="transition-colors duration-200 hover:text-primary-600">
                    {SITE.phone}
                  </a>
                </li>
                <li className="flex items-center gap-3 text-foreground-700">
                  <i className="ri-mail-line text-base text-primary-600" />
                  <a href={SITE.emailHref} className="transition-colors duration-200 hover:text-primary-600">
                    {SITE.email}
                  </a>
                </li>
              </ul>
            </div>
          </Reveal>

          <Reveal delay={120} className="lg:col-span-7">
            <div className="space-y-4">
              {addressItems.map((item) => (
                <div key={item.label} className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5">
                  <span className="flex h-11 w-11 flex-none items-center justify-center rounded-md bg-accent-100 text-xl text-accent-700">
                    <i className={item.icon} />
                  </span>
                  <div>
                    <p className="text-xs uppercase tracking-[0.14em] text-foreground-500">{item.label}</p>
                    <p className="mt-1 text-sm font-medium text-foreground-900">{item.value}</p>
                  </div>
                </div>
              ))}

              <div className="rounded-lg border border-background-200 bg-background-50 p-6">
                <h2 className="font-heading text-lg font-bold text-foreground-950">{t('imprint.disclaimerTitle')}</h2>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{t('imprint.disclaimer')}</p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}